import React from "react";

import { RegisterModalContent } from "./components/RegisterModalContent/index"
import "./style.scss";

export const RegisterForm = ({ labels }) => {

  return (
    <div role="dialog" className="modal fade login-modal" aria-label={labels.popupTitle} tabIndex="-1" id="login-form">
      <div className="modal-dialog">
        <div className="modal-content">
          <RegisterModalContent labels={labels}/>
        </div>
      </div>
    </div>
  );
};
